<template>
  <div class="app-layout">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
// This is a simple layout wrapper component
// It can be extended with navigation, sidebar, footer, etc.
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  background-color: #f5f5f5;
}
</style>
